import {fromJS} from 'immutable';
import * as types from 'constants/action-types';
import {
  setRecordsReducer,
  setCurrentRecordPageReducer,
  setCurrentRecordReducer,
  clearRecordsAfterPageReducer,
} from './base';

const initialState = fromJS({
  schoolPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentSchool: {},
  schoolFacultyPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentSchoolFaculty: {},
});

const setSchoolsReducer = (state, action) => setRecordsReducer('school', state, action);

const setCurrentSchoolPageReducer = (state, action) => setCurrentRecordPageReducer('school', state, action);

const setCurrentSchoolReducer = (state, action) => setCurrentRecordReducer('school', state, action);

const clearSchoolsAfterPageReducer = (state, action) => clearRecordsAfterPageReducer('school', state, action);

const setSchoolFacultiesReducer = (state, action) => setRecordsReducer('schoolFaculty', state, action);

const setCurrentSchoolFacultyPageReducer = (state, action) =>
  setCurrentRecordPageReducer('schoolFaculty', state, action);

const setCurrentSchoolFacultyReducer = (state, action) => setCurrentRecordReducer('schoolFaculty', state, action);

const clearSchoolFacultiesAfterPageReducer = (state, action) =>
  clearRecordsAfterPageReducer('schoolFaculty', state, action);

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    case types.SET_SCHOOLS:
      return setSchoolsReducer(state, action);
    case types.SET_CURRENT_SCHOOL_PAGE:
      return setCurrentSchoolPageReducer(state, action);
    case types.SET_CURRENT_SCHOOL:
      return setCurrentSchoolReducer(state, action);
    case types.CLEAR_SCHOOLS_AFTER_PAGE:
      return clearSchoolsAfterPageReducer(state, action);
    // School faculty
    case types.SET_SCHOOL_FACULTIES:
      return setSchoolFacultiesReducer(state, action);
    case types.SET_CURRENT_SCHOOL_FACULTY_PAGE:
      return setCurrentSchoolFacultyPageReducer(state, action);
    case types.SET_CURRENT_SCHOOL_FACULTY:
      return setCurrentSchoolFacultyReducer(state, action);
    case types.CLEAR_SCHOOL_FACULTIES_AFTER_PAGE:
      return clearSchoolFacultiesAfterPageReducer(state, action);
    default:
      return state;
  }
};
